module.exports = __webpack_public_path__ + "img/icon_img03.1133da98.png";